import React from 'react';
import UsersState from './usersState/UsersState';
import UsersControlPanel from './components/UsersControlPanel/UsersControlPanel';
import Users from './components/Users/Users';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const UsersPage: React.FC = () => {
	return (
		<UsersState>
			<div className={style.container} data-test="UsersPage">
				<UsersControlPanel />
				<Users />
				<ModalWindows />
			</div>
		</UsersState>
	);
};

export default UsersPage;
